export default class {
  constructor(element) {
    this.element = element;
  }

  show() {
    this.element.classList.add('is-visible');
  }

  hide() {
    this.element.classList.remove('is-visible');
  }
}
